import * as d3 from "d3";

export const FILTER_BUTTON_SIZE = 24;
export const FILTER_BUTTON_PADDING = 16;
export const FILTER_BUTTON_Y_OFFSET = 2;

export const addFilterButton = (
  plotClassName: string,
  padding: number,
  onClickCallback?: () => void,
  yOffset: number = FILTER_BUTTON_Y_OFFSET,
) => {
  const svg = d3.select(`svg.${plotClassName}`);

  const buttonGroup = svg
    .append("g")
    .classed("filter-button-svg", true)
    .attr("transform", `translate(${padding}, ${padding + yOffset})`)
    .style("cursor", "pointer")
    .style("opacity", "1");

  buttonGroup
    .append("rect")
    .attr("width", FILTER_BUTTON_SIZE)
    .attr("height", FILTER_BUTTON_SIZE)
    .attr("rx", 4)
    .attr("ry", 4)
    .attr("fill", "#0E98D0")
    .attr("fill-opacity", "1");

  buttonGroup
    .append("path")
    .attr(
      "d",
      "M9.54511 16.7241C9.33566 16.7241 9.16046 16.6536 9.01948 16.5125C8.87837 16.3715 8.80782 16.1963 8.80782 15.9868V11.1633L4.14282 5.23704C3.98254 5.02329 3.95927 4.80107 4.07302 4.57037C4.18691 4.33954 4.379 4.22412 4.64927 4.22412H15.4664C15.7366 4.22412 15.9287 4.33954 16.0426 4.57037C16.1564 4.80107 16.1331 5.02329 15.9728 5.23704L11.3078 11.1633V15.9868C11.3078 16.1963 11.2373 16.3715 11.0962 16.5125C10.9552 16.6536 10.78 16.7241 10.5705 16.7241H9.54511ZM10.0578 10.7241L14.1828 5.47412H5.93282L10.0578 10.7241Z",
    )
    .attr("fill", "white")
    .attr("fill-opacity", "1")
    .attr("transform", "translate(1.5, 1.5)");

  if (onClickCallback) {
    buttonGroup.on("click", onClickCallback);
  }

  return buttonGroup;
};
